<template>
  <div class="toast-notifications d-flex flex-column-reverse">
    <BaseToastNotification
      v-for="(notification, index) in globalStore.toastNotifications"
      v-bind="notification"
      :key="notification.id"
      :timeout="notification.timeout"
      :type="notification.type"
      :callback="notification.callback"
      :index="index"
    >
    <div class="d-flex">
      <v-icon v-if="notification.type">
        {{ getNotificationIcon(notification.type) }}
      </v-icon>
      <div @click="handleContentClick(notification.callback)" class="ml-3 d-flex flex-column">
        <h5 v-if="notification.title">
          {{ notification.title }}
        </h5>
        <p v-if="notification.message" class="mb-0 body-1">
          {{ getCollapsedMessage(notification.message) }}
        </p>
      </div>
    </div>
    </BaseToastNotification>
  </div>
</template>
<script setup lang="ts">
import useGlobalStore from '@/stores/modules/global'
import { TOAST_NOTIFICATION_ICONS } from '@/utils/constants/ui-constants'
import { BaseToastNotification } from '@/components/base'
import { getCollapsedString } from '@/utils/helpers'

const globalStore = useGlobalStore()
const getNotificationIcon = (type: string) =>
  Object.entries(TOAST_NOTIFICATION_ICONS).find(([key, value]) => key === type)?.[1]

const getCollapsedMessage = (message: string) => {
  return getCollapsedString(message, 100)
}

const handleContentClick = (callback: any) => {
  if (callback)
    callback()
};
</script>
<style lang="scss" scoped>
.toast-notifications {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  margin-right: 32px;
  margin-top: 96px;
}
</style>
